var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thanks",style:({ 'background-image' : `url(${_vm.background})`})},[_c('div',{staticClass:"container"},[_c('h1',[_vm._t("title")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2),_c('div',{staticClass:"link"},[_vm._t("link")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }